import {
  SendPdfReportRequest,
  PrintReportRequest
} from 'src/app/models/pos-reports-api.model';

export class GetEndOfDayReport {
  static readonly type = '[POS Reports] Get End Of Day Report';
  constructor(
    public readonly payload: {
      end_day_report: boolean;
      date: string;
      pos_location_id?: number;
      meal_id?: number;
    }
  ) {}
}

export class SendPdfReport {
  static readonly type = '[POS Reports] Send PDF Report';
  constructor(public readonly request: SendPdfReportRequest) {}
}

export class SendPdfReportSuccess {
  static readonly type = '[POS Reports] Send PDF Report Success';
  constructor(public readonly message: string) {}
}

export class SendPdfReportError {
  static readonly type = '[POS Reports] Send PDF Report Error';
  constructor(public readonly error: any) {}
}

export class PrintReport {
  static readonly type = '[POS Reports] Print Report';
  constructor(public readonly request: PrintReportRequest) {}
}

export class PrintReportError {
  static readonly type = '[POS Reports] Print Report Error';
  constructor(public readonly error: any) {}
}

export class GetReportRecipients {
  static readonly type = '[POS Reports] Get Report Recipients';
  constructor() {}
}

export class GetReportRecipientsSuccess {
  static readonly type = '[POS Reports] Get Report Recipients Success';
  constructor(public readonly recipients: string[]) {}
}

export class GetReportRecipientsError {
  static readonly type = '[POS Reports] Get Report Recipients Error';
  constructor(public readonly error: any) {}
}
